import { Col } from "antd";
import React, { Component } from "react";

export class BusinessProfileCard extends Component {
  render() {
    let { data } = this.props;
    return (
      <>
        {data?.map((item, i) => {
          return (
            <Col className="col-12 col-md-3" key={i} >
              <ul className="list-group custom_list_group">
                <li className="list-group-item">
                  <span className="key">Serial No</span>
                  <span className="me-3">:</span>
                  <span className="value">{item.Serial_No}</span>
                </li>
                <li className="list-group-item">
                  <span className="key">Partner Name</span>
                  <span className="me-3">:</span>
                  <span className="value">{item.Partner_Name}</span>
                </li>
                <li className="list-group-item">
                  <span className="key">DIN</span>
                  <span className="me-3">:</span>
                  <span className="value">{item.DIN}</span>
                </li>
                <li className="list-group-item">
                  <span className="key">Share Holding %</span>
                  <span className="me-3">:</span>
                  <span className="value">{item.Share_Holding}</span>
                </li>
              </ul>
            </Col>
          );
        })}
      </>
    );
  }
}

export default BusinessProfileCard;
